import {
  ArrowTopRightOnSquareIcon,
  Bars3Icon,
} from "@heroicons/react/24/outline";
import React from "react";
import styled, { css } from "styled-components";

import { FloatingMobileNavMenu } from "src/shared/components";
import { useDeviceSize } from "src/shared/hooks";

const MUSEUM_URL = "https://museum.hackthenorth.com/";

export const Museum: React.FC = () => {
  const isTabletOrSmaller = useDeviceSize("tablet");

  return (
    <Page>
      <Controls>
        {isTabletOrSmaller && (
          <FloatingMobileNavMenu>
            <OverlayIconButton
              type="button"
              aria-label="Open navigation menu"
              title="Open menu"
            >
              <Bars3Icon />
            </OverlayIconButton>
          </FloatingMobileNavMenu>
        )}
        <OpenInNewTabLink
          href={MUSEUM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Museum of Hack the North in a new tab"
          title="Open in new tab"
        >
          <ArrowTopRightOnSquareIcon />
        </OpenInNewTabLink>
      </Controls>
      <IframeScrollWrap>
        <MuseumEmbed
          src={MUSEUM_URL}
          title="Museum of Hack the North"
          scrolling="yes"
        />
      </IframeScrollWrap>
    </Page>
  );
};

const Page = styled.main`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  overflow: hidden;
`;

const Controls = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  left: 12px;
  z-index: 1;
  display: flex;
  align-items: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

const IframeScrollWrap = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

const overlayButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
  border-radius: ${({ theme }) => theme.globalConstants.borderRadius.small}px;
  background: ${({ theme }) => theme.globalConstants.color.white};
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  text-decoration: none;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }

  :hover {
    background: ${({ theme }) => theme.globalConstants.color.backgroundGray};
  }
`;

const OpenInNewTabLink = styled.a`
  ${overlayButtonStyles}
  margin-left: auto;
`;

const OverlayIconButton = styled.button`
  ${overlayButtonStyles}
`;

const MuseumEmbed = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  border: none;
`;
